import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const AwaitingApprovalPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: 'calc(100vh - 140px)',
      padding: '2rem',
      backgroundColor: '#f8f9fa'
    }}>
      <Card style={{ maxWidth: '600px', width: '100%' }}>
        <div style={{ textAlign: 'center' }}>
          {/* Icon */}
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#fef3c7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem'
          }}>
            <i className="pi pi-clock" style={{ fontSize: '2.5rem', color: '#f59e0b' }}></i>
          </div>

          {/* Title */}
          <h2 style={{ 
            fontSize: '1.5rem', 
            margin: '0 0 1rem 0', 
            color: '#1f2937',
            fontWeight: 600
          }}>
            Account Pending Approval
          </h2>

          {/* Message */}
          <p style={{ 
            color: '#6b7280', 
            margin: '0 0 1.5rem 0',
            fontSize: '1rem',
            lineHeight: '1.6'
          }}>
            Welcome, <strong>{user?.name}</strong>! Your account has been created successfully, 
            but it's currently awaiting approval from our administrators.
          </p>

          <p style={{ 
            color: '#6b7280', 
            margin: '0 0 2rem 0',
            fontSize: '0.95rem',
            lineHeight: '1.6'
          }}>
            You'll receive an email notification once your account has been approved. 
            In the meantime, you can update your profile information or explore our public resources.
          </p>

          {/* Status Badge */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            backgroundColor: '#fef3c7',
            borderRadius: '9999px',
            marginBottom: '2rem'
          }}>
            <i className="pi pi-info-circle" style={{ color: '#f59e0b' }}></i>
            <span style={{ color: '#92400e', fontWeight: 500, fontSize: '0.875rem' }}>
              Status: Pending Approval
            </span>
          </div>

          {/* Actions */}
          <div style={{ 
            display: 'flex', 
            gap: '1rem', 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Button 
              label="View Profile" 
              icon="pi pi-user"
              onClick={() => navigate('/app/profile')}
              className="p-button-outlined"
            />
            <Button 
              label="Browse Resources" 
              icon="pi pi-book"
              onClick={() => navigate('/resources')}
              className="p-button-outlined"
            />
          </div>

          {/* Contact Info */}
          <div style={{
            marginTop: '2rem',
            padding: '1rem',
            backgroundColor: '#f3f4f6',
            borderRadius: '8px'
          }}>
            <p style={{ 
              margin: 0, 
              fontSize: '0.875rem', 
              color: '#6b7280'
            }}>
              <i className="pi pi-question-circle" style={{ marginRight: '0.5rem' }}></i>
              Need help? Contact us at{' '}
              <a 
                href="mailto:support@sprono.com" 
                style={{ color: '#3B82F6', textDecoration: 'none' }}
              >
                support@sprono.com
              </a>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AwaitingApprovalPage;
